import FixedAside from "../helpers/Fixed-aside";
export default () => {

    const guidePage = document.querySelector('.size-guide');

    if (guidePage) {
        const tabs = guidePage.querySelectorAll('.size-guide-tabs__item');

        const contentWrappers = guidePage.querySelectorAll('.right-wrapper');
        
           
        tabs.forEach((tab, index)  => {
           
            tab.addEventListener("click", () => {
                
                for (let i=0; i<tabs.length;i++) {
                    tabs[i].classList.remove("active");
                }
                tab.classList.add("active");

                for(let i=0;i<contentWrappers.length; i++) {
                   
                    contentWrappers[i].classList.remove('active');
                    
                    if (i==index) {

                        contentWrappers[i].classList.add('active');
                    }
                   
                }
                
            })
        })
        
        const leftSide = guidePage.querySelector('.left-wrapper');
        const cont = guidePage.querySelectorAll('.container')[0];
        let props = {
            container: cont,
            aside: leftSide,
            fixedHeader: true
        }

        if(window.innerWidth > 1024){
            leftSide.style.height = window.innerHeight - document.querySelector('.header').offsetHeight - document.querySelector('.footer').offsetHeight + 'px';
        }

        let a = new FixedAside(props)
        a.init();

    }
}